exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layer[data-v-48fb550b] {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.layer>*[data-v-48fb550b] {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  min-height: 100%;\n  max-height: 100%;\n}\n.hover[data-v-48fb550b] {\n  cursor: pointer;\n  -webkit-box-shadow: 0 0 0 2px var(--clr-primary);\n          box-shadow: 0 0 0 2px var(--clr-primary);\n}\n", ""]);

// exports
